"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var ReactUtils_1 = require("../../../utils/ReactUtils");

var Directions;

(function (Directions) {
  Directions["VERTICAL"] = "lsg--iconlinkgroup__vertical";
  Directions["HORIZONTAL"] = "lsg--iconlinkgroup__horizontal";
  Directions["TABLE"] = "lsg--iconlinkgroup__table";
  Directions["FLIP_XS"] = "lsg--iconlinkgroup__flip-xs";
  Directions["FLIP_SM"] = "lsg--iconlinkgroup__flip-sm";
  Directions["FLIP_MD"] = "lsg--iconlinkgroup__flip-md";
  Directions["COLLAPSE_XS"] = "lsg--iconlinkgroup__collapse-xs";
  Directions["COLLAPSE_SM"] = "lsg--iconlinkgroup__collapse-sm";
  Directions["COLLAPSE_MD"] = "lsg--iconlinkgroup__collapse-md";
})(Directions || (Directions = {}));
/*
 * NOTE: difference between Children.map(children, child => <>child</>) and Children.toArray(children).map(child => <>child</>):
 * The first one doesn't remove empty children. So if you conditionally add items to IconLinkGroup, there will be an empty <li></li>.
 * The second one removes empty children by default, so the result will be cleaner.
 */


var IconLinkGroup =
/** @class */
function (_super) {
  __extends(IconLinkGroup, _super);

  function IconLinkGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  IconLinkGroup.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        id = _a.id,
        direction = _a.direction,
        htmlAttrs = _a.htmlAttrs;
    return React.createElement("ul", __assign({}, htmlAttrs, {
      id: id,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "iconlinkgroup", CSSPrefix_1.prefixEnumClassNames(direction), className])
    }), React.Children.map(children, function (child) {
      return ReactUtils_1.ReactUtils.map(child, function (iconLink) {
        return React.createElement("li", {
          className: CSSPrefix_1.lsgPre + "iconlinkgroup-li",
          key: child.key + "-" + iconLink.key
        }, iconLink);
      });
    }));
  };

  IconLinkGroup.Directions = Directions;
  IconLinkGroup.defaultProps = {
    direction: Directions.VERTICAL
  };
  return IconLinkGroup;
}(React.Component);

exports.IconLinkGroup = IconLinkGroup;